@if (latestSignatureRequest) {
  @if (latestSignatureRequest.status === 'expired') {
    <svg
      lucideClockAlert
      class="error"
      [matTooltip]="latestSignatureRequest.status | signatureRequestStatusLabel"
    ></svg>
  } @else if (latestSignatureRequest.status === 'canceled') {
    <svg
      lucideCircleX
      class="error"
      [matTooltip]="latestSignatureRequest.status | signatureRequestStatusLabel"
    ></svg>
  } @else if (latestSignatureRequest.status === 'deleted') {
    <svg
      lucideTrash
      class="error"
      [matTooltip]="latestSignatureRequest.status | signatureRequestStatusLabel"
    ></svg>
  } @else {
    <mat-icon
      svgIcon="yousign"
      [ngClass]="{
        pending: latestSignatureRequest.status === 'ongoing',
        success: latestSignatureRequest.status === 'done',
        error: ['rejected', 'declined', 'paused'].includes(latestSignatureRequest.status),
      }"
      [matTooltip]="latestSignatureRequest.status | signatureRequestStatusLabel"
    ></mat-icon>
  }
}
